import React from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import CoupleBanner from '../components/CoupleBanner';
import EventHighlightsSection from '../components/EventHighlightsSection';
import ExperienceSection from '../components/ExperienceSection';
import TicketSection from '../components/TicketSection';
import GallerySection from '../components/GallerySection';
import ContactSection from '../components/ContactSection';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const LandingPage = () => {
  const [scrollY, setScrollY] = React.useState(0);

  React.useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="smooth-scroll">
      <div className="grain-overlay" />
      <HeroSection scrollY={scrollY} />
      <AboutSection />
      <CoupleBanner />
      <EventHighlightsSection />
      <ExperienceSection />
      {/* <TicketSection /> */}
      <GallerySection />
      <ContactSection />
      <FAQSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default LandingPage;